import 'datepicker';
import $ from 'jquery';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Svg from 'rp-react-svg-icon';

/**
 * Represents date field with integrated datepicker jquery component
 */
export default class DatePicker extends PureComponent {
    static propTypes = {
        /**
         * Label of the input field
         */
        label: PropTypes.string.isRequired,
        /**
         * Input placeholder
         */
        placeholder: PropTypes.string,
        /**
         * Format of the selected date displayed inside input field
         */
        displayFormat: PropTypes.string,
        /**
         * Format of the date sent to server
         */
        valueFormat: PropTypes.string,
        /**
         * Selected date value
         */
        date: PropTypes.string,
        /**
         * Minimum allowed date to select
         */
        minDate: PropTypes.string,
        /**
         * Minimum allowed date to select
         */
        maxDate: PropTypes.string,
        /**
         * Action which happens after date is changed
         */
        onChange: PropTypes.func.isRequired,
    }

    static defaultProps = {
        placeholder: 'Select date',
        displayFormat: 'DD.MM.YYYY',
        valueFormat: 'YYYY-MM-DD',
        date: null,
        minDate: null,
        maxDate: null,
    }

    componentDidMount() {
        const { minDate, maxDate } = this.props;
        $(this.buttonRef)
            .datePicker({
                autoClose: true,
                minDate,
                maxDate,
            })
            .on('change.rp.datePicker', (ev, newDate) => this.props.onChange(
                format(newDate, this.props.valueFormat),
            ));
    }

    componentWillReceiveProps(nextProps) {
        ['minDate', 'maxDate'].forEach((key) => {
            if (this.isMinMaxDateChanged(nextProps, key)) {
                $(this.buttonRef).datePicker(key, nextProps[key]);
            }
        });
    }

    componentWillUnmount() {
        $(this.buttonRef).datePicker('destroy');
    }

    isMinMaxDateChanged(nextProps, key) {
        const fmt = this.props.valueFormat;
        return format(nextProps[key], fmt) !== format(this.props[key], fmt);
    }

    render() {
        const { label, placeholder, displayFormat, date } = this.props;
        return (
            <div className="search-datePicker">
                <span className="search-datePicker__label">{label}</span>
                <button
                    ref={(ref) => { this.buttonRef = ref; }}
                    className="search-button ui-btn ui-btn_tiertiary"
                    type="button"
                >
                    <div className="search-button__flexWrap">
                        <span>{date ? format(date, displayFormat) : placeholder}</span>
                        <Svg size="Medium" iconName="date" />
                    </div>
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/Common/DatePicker.jsx